// Vendor
import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Constants & utils
import { METRIC_ALERT_LIMIT } from 'AlertsApp/ts/features/alerts-modals/constants';
import { NOTE_ALERT } from 'NotesApp/ts/apps/notes-app/notes.constants';
// NgRx actions / selectors
import { ALERTS_MODAL_STATE_SLICE_KEY } from 'AlertsApp/ts/features/alerts-modals/state/alerts-modal.reducer';
import { deleteMetricAlert, disableMetricAlert, enableMetricAlert, setAlertNotes, } from 'AlertsApp/ts/features/alerts-modals/state/metric-alert-items/metric-alert-items.actions';
import { getMetricAlerts } from 'AlertsApp/ts/features/alerts-modals/state/alerts-modal.selectors';
import { resetErrorMessage, setErrorMessage, } from 'AlertsApp/ts/features/alerts-modals/state/alert-modal-status/alert-modal-status.actions';
// Services
import { AlertsService } from 'AlertsApp/ts/services/alerts.service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { SharingModalComponent } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.component';
import { NotesModalComponent } from 'NotesApp/ts/apps/notes-app/components/notes-modal/notes-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "AlertsApp/ts/services/alerts.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i6 from "../../../../../../../../notes/static/notes/ts/apps/notes-app/components/notes-modal/notes-modal.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/sharing-modal/sharing-modal.component";
import * as i8 from "AlertsApp/ts/features/alerts-modals/components/metric-alerts-list-item/metric-alerts-list-item.component";
const _c0 = (a0, a1, a2, a3) => ({ id: a0, type: a1, name: a2, sharing: a3 });
function MetricAlertsListComponent_ycn_loading_symbol_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 8);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Deleting Alert");
} }
function MetricAlertsListComponent_tr_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 9);
    i0.ɵɵlistener("deleteButtonHandler", function MetricAlertsListComponent_tr_6_Template_tr_deleteButtonHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openDeleteConfirmModal($event)); })("shareButtonHandler", function MetricAlertsListComponent_tr_6_Template_tr_shareButtonHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openSharingModal($event)); })("disableButtonHandler", function MetricAlertsListComponent_tr_6_Template_tr_disableButtonHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleMetricAlertDisabledHandler($event)); })("openNotesModal", function MetricAlertsListComponent_tr_6_Template_tr_openNotesModal_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openNotesModal($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const alert_r3 = ctx.$implicit;
    i0.ɵɵproperty("alert", alert_r3);
} }
function MetricAlertsListComponent_ycn_sharing_modal_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-sharing-modal", 10);
    i0.ɵɵlistener("completeHandler", function MetricAlertsListComponent_ycn_sharing_modal_9_Template_ycn_sharing_modal_completeHandler_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.sharingHandler()); })("closeModalHandler", function MetricAlertsListComponent_ycn_sharing_modal_9_Template_ycn_sharing_modal_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetAlertToShare()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("shareableItem", ctx_r1.alertToShare)("excludeEditPermission", true);
} }
/**
 * MetricAlertsListComponent.
 *
 * List of Metric alerts created by the user.
 *
 */
export class MetricAlertsListComponent {
    constructor(alertsService, changeDetector, store) {
        this.alertsService = alertsService;
        this.changeDetector = changeDetector;
        this.store = store;
        this.sharingCallback = new EventEmitter();
        this.alertsList = [];
        this.showDeletingModal = false;
        this.NOTE_ALERT = NOTE_ALERT;
        this.mapStateToComponent = (state) => {
            this.alertsList = getMetricAlerts(state);
            if (this.notesModalAlert !== undefined) {
                // update notes modal alert with the alert in store so changes to notes are reflected in the notes modal
                this.notesModalAlert = state.metricAlertItems.find((alert) => alert.id === this.notesModalAlert.id);
            }
        };
        this.storeSubscription = store.select(ALERTS_MODAL_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    trackById(index, alert) {
        return alert.id;
    }
    /**
     * Opens the notes modal for the given alert.
     *
     * @param alert: Alert to open the notes modal for.
     */
    openNotesModal(alert) {
        this.notesModalAlert = alert;
        this.changeDetector.detectChanges();
        this.notesModal.openModal();
    }
    resetNotesModalAlert() {
        this.notesModalAlert = undefined;
    }
    updateAlertNotesHandler(updated) {
        const alertToUpdate = this.alertsList.find((alert) => alert.id === updated.id);
        if (alertToUpdate) {
            this.store.dispatch(setAlertNotes({ alert: alertToUpdate, notes: updated.notes }));
        }
    }
    /**
     * Handler for the delete button. Opens the confirmation modal.
     *
     * @param alert: Alert to be deleted.
     */
    openDeleteConfirmModal(alert) {
        this.alertToDelete = alert;
        this.deleteConfirmModal.openModal();
    }
    /**
     * Handler for the delete-confirm modal. If the action is confirmed emits `deleteHandler` to handle the delete action.
     *
     * @param confirmed: Whether the deleted action is confirmed or not.
     */
    confirmDeleteHandler(confirmed) {
        if (confirmed && this.alertToDelete) {
            this.deleteMetricAlert(this.alertToDelete);
        }
        this.alertToDelete = undefined;
    }
    /**
     * Deletes the selected alert. Dispatches `deleteMetricAlert` to remove the alert from the state.
     *
     * @param selectedAlert: Metric alert to be deleted.
     */
    deleteMetricAlert(selectedAlert) {
        this.showDeletingModal = true;
        this.alertsService
            .deleteAlert(selectedAlert.alert_type, selectedAlert.object_type, selectedAlert.id)
            .subscribe({
            next: () => {
                this.store.dispatch(deleteMetricAlert({ alert: selectedAlert }));
                this.store.dispatch(resetErrorMessage());
            },
            error: () => {
                this.store.dispatch(setErrorMessage({
                    errorMessage: 'Alert deletion failed. Please refresh the page or contact support.',
                }));
            },
            complete: () => {
                this.showDeletingModal = false;
            },
        });
    }
    /**
     * Handler for the share button. Opens the sharing modal.
     *
     * @param alert: Alert to be shared.
     */
    openSharingModal(alert) {
        this.alertToShare = alert;
        // Manually detect changes to make sure the sharing modal is initialized before we open it
        this.changeDetector.detectChanges();
        this.alertSharingModal.openModal();
    }
    /**
     * Handler for the sharing modal. If the action is confirmed emits `sharingCallback` to handle the share action.
     *
     * @param confirmed: Whether the sharing action is confirmed or not.
     */
    sharingHandler() {
        this.sharingCallback.emit();
    }
    resetAlertToShare() {
        this.alertToShare = undefined;
    }
    /**
     * Disables or enables a metric alert based on the current disabled preference.
     *
     * @param metricAlert: The selected metric alert.
     */
    toggleMetricAlertDisabledHandler(metricAlert) {
        if (metricAlert.disabled_alert_preference_id) {
            this.enableMetricAlert(metricAlert);
        }
        else {
            this.disableMetricAlert(metricAlert);
        }
    }
    /**
     * Enables a metric alert based on the current disabled preference.
     *
     * @param metricAlert: The selected metric alert.
     */
    enableMetricAlert(metricAlert) {
        if (!metricAlert.disabled_alert_preference_id)
            return;
        this.alertsService.enableAlert(metricAlert.disabled_alert_preference_id).subscribe({
            next: () => {
                this.store.dispatch(enableMetricAlert({ alert: metricAlert }));
            },
            error: () => {
                this.store.dispatch(setErrorMessage({
                    errorMessage: 'Alert enabling failed. Please refresh the page or contact support.',
                }));
            },
        });
    }
    /**
     * Disables a metric alert based on the current disabled preference.
     *
     * @param metricAlert: The selected metric alert.
     */
    disableMetricAlert(metricAlert) {
        this.alertsService.disableAlert(METRIC_ALERT_LIMIT, metricAlert.object_type, metricAlert.id).subscribe({
            next: (disablePreference) => {
                const disabledAlertPreferenceId = disablePreference.id;
                this.store.dispatch(disableMetricAlert({ alert: metricAlert, disabledAlertPreferenceId }));
            },
            error: () => {
                this.store.dispatch(setErrorMessage({
                    errorMessage: 'Alert disabling failed. Please refresh the page or contact support.',
                }));
            },
        });
    }
}
MetricAlertsListComponent.ɵfac = function MetricAlertsListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MetricAlertsListComponent)(i0.ɵɵdirectiveInject(i1.AlertsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Store)); };
MetricAlertsListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MetricAlertsListComponent, selectors: [["ycn-metric-alerts-list"]], viewQuery: function MetricAlertsListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
        i0.ɵɵviewQuery(NotesModalComponent, 5);
        i0.ɵɵviewQuery(SharingModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.deleteConfirmModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.notesModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alertSharingModal = _t.first);
    } }, inputs: { alertObject: "alertObject" }, outputs: { sharingCallback: "sharingCallback" }, standalone: false, decls: 10, vars: 14, consts: [[3, "loaderMessage", 4, "ngIf"], [1, "modal-section", "notes-section"], [1, "form-label", "form-label-thin", "form-row"], [1, "table", "notes"], ["ycn-metric-alerts-list-item", "", 3, "alert", "deleteButtonHandler", "shareButtonHandler", "disableButtonHandler", "openNotesModal", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [3, "updateHandler", "closeHandler", "noteType", "parentModelInfo"], [3, "shareableItem", "excludeEditPermission", "completeHandler", "closeModalHandler", 4, "ngIf"], [3, "loaderMessage"], ["ycn-metric-alerts-list-item", "", 3, "deleteButtonHandler", "shareButtonHandler", "disableButtonHandler", "openNotesModal", "alert"], [3, "completeHandler", "closeModalHandler", "shareableItem", "excludeEditPermission"]], template: function MetricAlertsListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MetricAlertsListComponent_ycn_loading_symbol_0_Template, 1, 1, "ycn-loading-symbol", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "Existing Metric Alerts");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "table", 3)(5, "tbody");
        i0.ɵɵtemplate(6, MetricAlertsListComponent_tr_6_Template, 1, 1, "tr", 4);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(7, "ycn-confirm-modal", 5);
        i0.ɵɵlistener("confirmHandler", function MetricAlertsListComponent_Template_ycn_confirm_modal_confirmHandler_7_listener($event) { return ctx.confirmDeleteHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-notes-modal", 6);
        i0.ɵɵlistener("updateHandler", function MetricAlertsListComponent_Template_ycn_notes_modal_updateHandler_8_listener($event) { return ctx.updateAlertNotesHandler($event); })("closeHandler", function MetricAlertsListComponent_Template_ycn_notes_modal_closeHandler_8_listener() { return ctx.resetNotesModalAlert(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, MetricAlertsListComponent_ycn_sharing_modal_9_Template, 1, 2, "ycn-sharing-modal", 7);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showDeletingModal);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.alertsList)("ngForTrackBy", ctx.trackById);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonText", "OK")("confirmHeader", "Delete Alert")("confirmText", "Are you sure you want to delete this alert?");
        i0.ɵɵadvance();
        i0.ɵɵproperty("noteType", ctx.NOTE_ALERT)("parentModelInfo", i0.ɵɵpureFunction4(9, _c0, ctx.notesModalAlert == null ? null : ctx.notesModalAlert.id, ctx.notesModalAlert == null ? null : ctx.notesModalAlert.object_type, "Notes for " + (ctx.notesModalAlert == null ? null : ctx.notesModalAlert.object_name) + " " + (ctx.notesModalAlert == null ? null : ctx.notesModalAlert.description), ctx.notesModalAlert == null ? null : ctx.notesModalAlert.sharing));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.alertToShare);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.ConfirmModalComponent, i5.LoadingSymbolComponent, i6.NotesModalComponent, i7.SharingModalComponent, i8.MetricAlertsListItemComponent], encapsulation: 2 });
